//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import common from '../../api/common'
export default {
    data(){
        return{
            times:common,
            types:this.$route.query.types,
            details: this.$route.query.data
        }
    },
    created(){
       document.title = '预约挂号详情';
    }
}



// WEBPACK FOOTER //
// ./src/views/myRegisteredDetails/index.vue